const LABEL_VALID_ERROR_NAME = "label-valid-error";

function formValidate(formName) {
  // Section bị ẩn (vd form cha khi "chưa xác định thông tin cha") => ref chưa mount => coi như hợp lệ
  if (!formName || !formName.current) return true;
  return !formChildValidate(formName.current);
}

function formChildValidate(tag) {
  let count = 0;
  if (tag.children.length <= 0) return count;
  for (let i = tag.children.length - 1; i >= 0; i--) {
    let element = tag.children[i];
    let name = element.getAttribute("name");
    if (name === LABEL_VALID_ERROR_NAME) {
      return 1;
    } else {
      count += formChildValidate(element);
    }
  }
  return count;
}

module.exports = { formValidate, formChildValidate, LABEL_VALID_ERROR_NAME };
